import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5","key":"svg-0"}],["path",{"d":"M18 8h-12","key":"svg-1"}],["path",{"d":"M18 11h-12","key":"svg-2"}]]

const IconCurrencyPeso = createReactComponent('outline', 'currency-peso', 'CurrencyPeso', __iconNode);

export default IconCurrencyPeso;